import React from "react";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import UploadProformaInvoicePageModal from "@/features/invoices/proforma-invoices/upload-proforma-invoice-page-modal";
import { LightOrderSheetSet } from "@/features/order-sheets/order-sheet.type";
import UploadOrderConfirmationInvoicePageModal
  from "@/features/invoices/order-confirmation-invoices/upload-order-confirmation-invoice-page-modal";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  buyerId: number;
  boutiqueId: number;
  orderSheetSet: LightOrderSheetSet;
  // 라인시트세트 시즌 — OC 시즌 기본값
  season?: string;
}

export default function AddOrderConfirmationInvoiceModal({ isOpen, onClose, buyerId, boutiqueId, orderSheetSet, season }: Props) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent borderRadius={"8px"} overflow={"hidden"} maxWidth={"1600px"}>
        <ModalBody display="flex" flexDirection={"column"} gap={"12px"} >
          <UploadOrderConfirmationInvoicePageModal
            buyerId={buyerId}
            boutiqueId={boutiqueId}
            orderSheetSet={orderSheetSet}
            season={season}
            handleClose={handleClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
